import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetPatientArgs, Patient } from "../schemas/patient";

type QueryKey = readonly ["getPatientProfile", number, number | null | undefined];

const getPatientProfileQueryKey = (args: GetPatientArgs): QueryKey =>
  ["getPatientProfile", args.patientID, args.treatment_id] as const;

export const useGetPatientProfile = (
  args: GetPatientArgs,
  options?: UseQueryOptions<Patient, Error, Patient, QueryKey>
) => {
  const client = useApiClient();

  return useQuery(getPatientProfileQueryKey(args), () => client.getPatientProfile(args), options);
};
